import React, { Fragment } from "react";
import { Field, getFormValues, reduxForm } from "redux-form";
import { _capitalizeText } from "../../../../shared/helpers/utils";
import renderDropZoneField from "./DropZone";
import { setUserProfile } from "../../../../redux/actions/authActions";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { display } from "@material-ui/system";

const styles = (theme) => ({

  mediaContainer:{display:"flex",
    gap:"1rem",
    justifyContent:"center",
    marginTop:"1rem"

  },

});
class MediaUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = { snackShow: { show: false, message: "", type: "" } };
    this.handleSaveLogo = this.handleSaveLogo.bind(this);
    this.Photos=[
      {label: "Primary Photo"},
      {label: "Photo 2"},
      {label: "Photo 3"},
      {label: "Floor Plan"}
    ]
  }

  snackOpen(message, type) {
    this.setState({
        snackShow: {
          show:true,
          message,
          type,
        },
      });
  }
  handleSaveLogo = async (media, index) => {
    console.log(media,index)
    const { setPropertyDetails } = this.props;
    setPropertyDetails((prevDetails) => {
      const updatedImages = [...(prevDetails.images || [])];
      updatedImages[index] = media;
    
      return {
        ...prevDetails,
        images: updatedImages,
      };
    });
    
  };

  render() {
    const { user, classes, propertyDetails } = this.props;
  
    return (
      <div className={classes.mediaContainer}>
        {this.Photos.map((item, index) => {
            let img = propertyDetails && propertyDetails['images'] && propertyDetails['images'][index] ? propertyDetails['images'][index] : null;
            return(  <Field
                key={index}
                name={`media-${index}`}
                label={item.label}
                component={renderDropZoneField}
                SnapShotDropZoneHeight={true}
                SnapShotDropLoader={true}
                defaultImage={img|| null}
                callback={(media) => this.handleSaveLogo(media, index)} 
              />)
        }
        
        )}
      </div>
    );
  }
  
}

const mapStateToProps = (state) => {
  return {
    formLogo: getFormValues("media-logo")(state),
    user: state.user,
  };
};

const formWrapped = reduxForm({
  form: "media-logo", 
})(MediaUpload);

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(formWrapped)
);
